<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">Would you like to create <strong>{{data.name}}__</strong>?</p>
    <button type="button" @click="create" class="btn btn-fill btn-info">
      Yes
    </button>
    <button type="button" @click="closeModal" class="btn btn-fill btn-info">
      No
    </button>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        addLegalSubdivision: false
      }
    },
    methods: {
      create() {
        this.addLegalSubdivision = true
        this.$eventHub.$emit('show-modal-3', 'Legal Subdivision', this.data, '500px')
      },
      closeModal() {
        this.$emit('close')
      }
    },
    destroyed() {
      if (!this.addLegalSubdivision) {
        this.$eventHub.$emit('noLegalSubdivisionSaved')
      }
    }
  }
</script>
